import {AfterViewInit, Component, Inject, ViewChild, ElementRef} from '@angular/core';
import {DialogResult, DialogResultType} from '../DialogResult';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {Observable} from 'rxjs/internal/Observable';
import {ShareState} from '../../elements/share-editor/share-editor.component';
import {DodBatchLayoutEx} from '../../api/models/dod-batch-layout-ex';
import {DodEndPointEx} from '../../api/models/dod-end-point-ex';
import {DodEndPointDimension} from '../../api/models/dod-end-point-dimension';
import {DodEndPointMeasureEx} from '../../api/models/dod-end-point-measure-ex';
import {DodEndPointColumn} from '../../api/models/dod-end-point-column';
import {DodEndPointAggregateType} from '../../api/models/dod-end-point-aggregate-type'
import {FullTitleSearchComponent} from '../../elements/filter-editor/full-title-search/full-title-search.component';
import {AzureConfig} from '../../api/models/azure-config';
import {AwsConfig} from '../../api/models/aws-config';
import {SftpConfig} from '../../api/models/sftp-config';
import {EmailConfig} from '../../api/models/email-config';
import {PreFilter} from '../../api/models/pre-filter';
import {FilterKeys} from '../../api/models/filter-keys';
import {FilterEditorDialogComponent, FilterEditorDialogResult} from '../filter-editor-dialog/filter-editor-dialog.component';
import {US_SubHeader} from '../../api/models/us_sub-header';
import {UserState} from '../../api/models/user-state';
import {PreFilterDialogResult, PreFilterEditorDialogComponent} from '../pre-filter-editor-dialog/pre-filter-editor-dialog.component';
import {UserStateEx} from '../../api/models-ex/user-state-ex';
import {GlobalApp} from '../../tools/global';
import {SubscriptionService} from '../../api/services/subscription.service';
import {PreFilterService} from '../../api/services/pre-filter.service';
import {US_PreFilter} from '../../api/models/us_pre-filter';
import {MatSnackBar} from '@angular/material/snack-bar';
import {DataOnDemandEndPointConfigDialogComponent} from '../data-on-demand-end-point-config-dialog/data-on-demand-end-point-config-dialog.component';
import {ConfirmDialogComponent} from '../confirm-dialog/confirm-dialog.component';


export enum DataOnDemandDestinationType {
  Email = 0,
  Sftp = 1,
  AzureBlob = 2,
  AWS = 3
  // 4 = retired (was AI Chat - the file-upload/code_execution AI chat mode it fed has been removed)
  // 5 = retired (was a separate data-model feature, since removed)
}

export class DodLayoutDialogData {
  dodLayout: DodBatchLayoutEx;
  allEndPoints: DodEndPointEx[];
  shareState: ShareState;
  preFilters: US_PreFilter[];
  isOwner: boolean;
  userState: UserState;
}

export class DataOnDemandLayoutDialogResult {
  dodLayout: DodBatchLayoutEx;
  shareState: ShareState;
}

@Component({
  selector: 'data-on-demand-layout-dialog',
  templateUrl: './data-on-demand-layout-dialog.component.html',
  styleUrls: ['./data-on-demand-layout-dialog.component.css'],
})
export class DataOnDemandLayoutDialogComponent implements AfterViewInit {

  @ViewChild(FullTitleSearchComponent, {static: false}) titleSearchComponent: FullTitleSearchComponent;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;

  public result: DataOnDemandLayoutDialogResult;
  public selectedSubscriptionId: number = -1;
  public shareState: ShareState;
  public isOwner: boolean;
  public allEndPoints: DodEndPointEx[] = [];
  public errorMessage: string | undefined = undefined;
  public filteringSource: number | null = null;

  public errorMessages: string[] = [];
  public statusMessage: string | undefined = undefined;

  public destinationId : DataOnDemandDestinationType = DataOnDemandDestinationType.Email;

  public azureConfig: AzureConfig = {
    connectionString: "",
    containerName: "",
    path: "",
    folderPerEndPoint: false
  };

  public awsConfig: AwsConfig = {
    accessKey: "",
    secretKey: "",
    region: "",
    bucketName: "",
    path: "",
    folderPerEndPoint: false
  };

  public sftpConfig: SftpConfig = {
    host: "",
    port: 0,
    userName: "",
    password: "",
    path: "",
    folderPerEndPoint: false
  };

  public emailConfig: EmailConfig = {
    emailAddress: ""
  };

  public subscriptions: US_SubHeader[] = [];
  public dod_subscriptions: US_SubHeader[] = [];

  constructor(
    private app: GlobalApp,
    private subscriptionService: SubscriptionService,
    private preFilterService: PreFilterService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dialogRef: MatDialogRef<DataOnDemandLayoutDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DodLayoutDialogData
  ) {

    this.result = {
      dodLayout: JSON.parse(JSON.stringify(data.dodLayout)),
      shareState: data.shareState
    }

    if (!this.result.dodLayout.endPoints) {
      this.result.dodLayout.endPoints = [];
    }

    this.allEndPoints = data.allEndPoints;
    this.getDodSubscriptions();
    if (this.result.dodLayout.subscriptionId) {
      this.selectedSubscriptionId = this.result.dodLayout.subscriptionId;
    } else if (this.dod_subscriptions.length > 0) {
      this.selectedSubscriptionId = this.dod_subscriptions[0].subscriptionId;
    }
    this.shareState = data.shareState;
    this.isOwner = data.isOwner;
    this.destinationId = this.result.dodLayout.destinationId;
    this.filteringSource = this.result.dodLayout.preFilterId;

    if (this.result.dodLayout.emailConfig) {
      this.emailConfig = JSON.parse(JSON.stringify(this.result.dodLayout.emailConfig));
    }
    if (this.result.dodLayout.sftpConfig) {
      this.sftpConfig = JSON.parse(JSON.stringify(this.result.dodLayout.sftpConfig));
    }
    if (this.result.dodLayout.azureConfig) {
      this.azureConfig = JSON.parse(JSON.stringify(this.result.dodLayout.azureConfig));
    }
    if (this.result.dodLayout.awsConfig) {
      this.awsConfig = JSON.parse(JSON.stringify(this.result.dodLayout.awsConfig));
    }

    this.Result = new DialogResult();
    this.Result.ResultType = DialogResultType.Cancel;
    this.Result.ResultData = null;
  }

  getEndPointTitle(dodEndPointId: number): string {
    return this.allEndPoints.find(x => x.dodEndPointId === dodEndPointId)?.title ?? "Unknown";
  }

  addEndPoint(endPoint: DodEndPointEx) {
    if (endPoint) {
      if (!this.result.dodLayout.endPoints.find(x => x.dodEndPointId === endPoint.dodEndPointId)) {
        this.result.dodLayout.endPoints.push({
          dodBatchLayoutId: this.result.dodLayout.dodBatchLayoutId,
          dodEndPointId: endPoint.dodEndPointId,
          columnsSelected: "",
          dimensionsSelected: "",
          measuresSelected: "",
          subDataSelected: ""
        });
      }
    }
  }

  removeEndPoint(index: number) {
    this.result.dodLayout.endPoints.splice(index, 1);
    return false;
  }

  configureEndPoint(index: number) {
    const endPoint = this.result.dodLayout.endPoints[index];
    const endPointEx = this.allEndPoints.find(x => x.dodEndPointId === endPoint.dodEndPointId);

    if (endPointEx) {
      DataOnDemandEndPointConfigDialogComponent.showDialog(this.dialog, endPoint, endPointEx).subscribe(result => {
        if (result) {
          this.result.dodLayout.endPoints[index] = result;
        }
      });
    }

    return false;
  }

  ngAfterViewInit() {
  }

  handleFileInput(files: FileList) {
    if (this.isFilterEmpty(this.result.dodLayout.directFilterData)) {
      this.processTemplate(files);
    } else {
      ConfirmDialogComponent.showDialog(this.dialog, 'Overwrite Filter?', 'Are you sure you want to overwrite the current filter?').subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          this.processTemplate(files);
        } else {
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
        }
      });
    }
  }

  private isFilterEmpty(filterData: string | undefined): boolean {
    if (!filterData || filterData === '{}') {
      return true;
    }

    try {
      const keys = JSON.parse(filterData);
      // If it's the default "Last Month" filter with no other selections, we consider it empty
      return keys.dateRangeType === 1 &&
        keys.dateRange === 2 &&
        (!keys.titles || keys.titles.length === 0) &&
        (!keys.occupations || keys.occupations.length === 0) &&
        (!keys.companies || keys.companies.length === 0) &&
        (!keys.industries || keys.industries.length === 0) &&
        (!keys.locations || keys.locations.length === 0) &&
        (!keys.metroGroups || keys.metroGroups.length === 0) &&
        (!keys.attributes || keys.attributes.length === 0) &&
        (!keys.educationInstitutions || keys.educationInstitutions.length === 0);
    } catch (e) {
      return false;
    }
  }

  private processTemplate(files: FileList) {
    this.errorMessages = [];
    this.statusMessage = undefined;
    const uploadFile = files.item(0);
    if (uploadFile) {
      if (uploadFile.size > 10000000) {
        this.errorMessages.push('ERROR: File size is too large. Max file size is 10MB.');
        if (this.fileInput?.nativeElement) {
          this.fileInput.nativeElement.value = '';
        }
        return;
      }
      this.statusMessage = 'Processing ' + uploadFile.name + ', Please Wait...';
      this.preFilterService.preFilterProcessPreFilterTemplate(uploadFile).subscribe({
        next: result => {
          if (result.hasError) {
            this.errorMessages.push('ERROR: ' + result.errorMessage);
            this.statusMessage = undefined;
            if (this.fileInput?.nativeElement) {
              this.fileInput.nativeElement.value = '';
            }
          } else {
            this.result.dodLayout.directFilterData = result.filter;
            this.statusMessage = 'SUCCESS: Template Applied';
            if (this.fileInput?.nativeElement) {
              this.fileInput.nativeElement.value = '';
            }
          }
        },
        error: err => {
          this.errorMessages.push('ERROR: Upload failed ' + err);
          this.statusMessage = undefined;
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
        },
        complete: () => {
          // Clear file input so the same file can be re-selected if needed
          if (this.fileInput?.nativeElement) {
            this.fileInput.nativeElement.value = '';
          }
        }
      });
    }
  }

  editDirectFilter(): boolean {
    const selectedEndPoints = this.result.dodLayout.endPoints.map(ep => this.allEndPoints.find(aep => aep.dodEndPointId === ep.dodEndPointId)).filter(x => x);

    FilterEditorDialogComponent.showDialog(
      this.dialog,
      this.result.dodLayout.directFilterData,
      selectedEndPoints,
      this.filteringSource !== -1 ? true : undefined,
      this.allEndPoints
    ).subscribe(result => {
      if (result.ResultType === DialogResultType.Ok) {
        const results: FilterEditorDialogResult = result.ResultData;
        this.result.dodLayout.directFilterData = results.filterData;
      }
    });

    return false;
  }

  public hasEndPointSpecificFilters(): boolean {
    const selectedEndPoints = this.result.dodLayout.endPoints.map(ep => this.allEndPoints.find(aep => aep.dodEndPointId === ep.dodEndPointId)).filter(x => x);
    if (selectedEndPoints.length === 0) {
      return false;
    }

    return selectedEndPoints.some(ep => ep.filters?.some(f => f.endPointSpecific));
  }

  public getDodSubscriptions() {
    let subs : US_SubHeader[] = [];
    this.allEndPoints.forEach(x => {
      subs = subs.concat(x.subHeaders);
    });

    const seen = new Set();
    this.dod_subscriptions = subs.filter(sub => {
      const key = sub.subscriptionId;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  public getPreFilterSubscriptions() {
    if (this.data.userState) {
      this.subscriptions = UserStateEx.getAllSubscriptions(this.data.userState);
    }

    return this.subscriptions;
  }

  copyPreFilterToDirect(): void {
    const preFilter = this.data.preFilters.find(x => x.preFilterId === this.filteringSource);
    if (!preFilter) {
      return;
    }

    const performCopy = () => {
      this.result.dodLayout.directFilterData = preFilter.filterData;
      this.filteringSource = -1;
      this.snackBar.open("PreFilter copied to Direct Filter", null, {
        duration: 5000
      });
    };

    if (this.isFilterEmpty(this.result.dodLayout.directFilterData)) {
      performCopy();
    } else {
      ConfirmDialogComponent.showDialog(this.dialog, 'Overwrite Filter?', 'Are you sure you want to overwrite the current filter?').subscribe(result => {
        if (result.ResultType === DialogResultType.Ok) {
          performCopy();
        }
      });
    }
  }

  public Result: DialogResult;

  static showDialog(
    dialog: MatDialog,
    allEndPoints: DodEndPointEx[],
    dodLayout: DodBatchLayoutEx,
    shareState: ShareState,
    preFilters: US_PreFilter[],
    isOwner: boolean,
    userState: UserState
  ): Observable<DialogResult> {
    const params: DodLayoutDialogData = {
      allEndPoints,
      dodLayout,
      shareState,
      preFilters,
      isOwner,
      userState
    };

    const dialogRef = dialog.open(DataOnDemandLayoutDialogComponent, {
      disableClose: true,
      width: '900px',
      data: params,

    });

    return dialogRef.afterClosed();
  }

  onCancelClick(): void {
    this.dialogRef.close(this.Result);
  }

  onSaveLayout(): void {
    this.closeDialog();
  }

  closeDialog(): void {
    if (!this.result.dodLayout.directFilterData || this.result.dodLayout.directFilterData === '' || this.result.dodLayout.directFilterData === '{}') {
      const defaultFilter: FilterKeys = {
        titles: [],
        occupations: [],
        companies: [],
        industries: [],
        locations: [],
        metroGroups: [],
        attributes: [],
        educationInstitutions: [],
        jobPosting: {
          postingsWithCompensation: null,
          compensationRateMinimum: null,
          compensationRateMaximum: null
        },
        sourceJobPosting: {
          primaryJobType: null,
          jobStatus: null,
          minMidSalary: null,
          maxMidSalary: null,
          urgent: null,
          sponsored: null,
          applyOnIndeed: null,
          remoteStatus: null
        },
        dateRangeType: 1,
        dateRange: 2,
        flags: {
          useCleanLocations: 'true',
          useMetroGroups: 'false'
        }
      };
      this.result.dodLayout.directFilterData = JSON.stringify(defaultFilter);
    }

    this.errorMessage = undefined;

    if (!this.result.dodLayout.name || this.result.dodLayout.name.trim() === '') {
      this.errorMessage = "Layout Name Cannot Be Blank.";
      return;
    }

    if (!this.result.dodLayout.notificationEmail || this.result.dodLayout.notificationEmail.trim() === '') {
      this.errorMessage = "Notification Email Cannot Be Blank.";
      return;
    }

    if (this.destinationId === DataOnDemandDestinationType.Email) {

    } else if (this.destinationId === DataOnDemandDestinationType.Sftp) {
      if (
        !this.sftpConfig.path || this.sftpConfig.path.trim() === '' ||
        !this.sftpConfig.host || this.sftpConfig.host.trim() === '' ||
        !this.sftpConfig.userName || this.sftpConfig.userName.trim() === '') {
        this.errorMessage = "At least Path, Host & User Name SFTP Fields Required.";
        return;
      } else if (!this.sftpConfig.password || this.sftpConfig.password.trim() === '') {
        if (!this.sftpConfig.privateKey || this.sftpConfig.privateKey.trim() === '') {
          this.errorMessage = "Either Password or Private Key required for SFTP.";
          return;
        }
      }
    } else if (this.destinationId === DataOnDemandDestinationType.AzureBlob) {
      if (
        !this.azureConfig.connectionString || this.azureConfig.connectionString.trim() === '' ||
        !this.azureConfig.containerName || this.azureConfig.containerName.trim() === '' ||
        !this.azureConfig.path || this.azureConfig.path.trim() === '') {
        this.errorMessage = "All Azure Fields Required.";
        return;
      }
    } else if (this.destinationId === DataOnDemandDestinationType.AWS) {
      if (
        !this.awsConfig.path || this.awsConfig.path.trim() === '' ||
        !this.awsConfig.region || this.awsConfig.region.trim() === '' ||
        !this.awsConfig.accessKey || this.awsConfig.accessKey.trim() === '' ||
        !this.awsConfig.secretKey || this.awsConfig.secretKey.trim() === '' ||
        !this.awsConfig.bucketName || this.awsConfig.bucketName.trim() === '') {
        this.errorMessage = "All AWS Fields Required.";
        return;
      }
    }

    this.result.dodLayout.subscriptionId = this.selectedSubscriptionId;
    this.result.shareState = this.shareState;
    this.result.dodLayout.destinationId = this.destinationId;
    this.result.dodLayout.preFilterId = this.filteringSource;

    if (this.destinationId === DataOnDemandDestinationType.Email) {
      this.result.dodLayout.emailConfig = this.emailConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.Sftp) {
      this.result.dodLayout.sftpConfig = this.sftpConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.AzureBlob) {
      this.result.dodLayout.azureConfig = this.azureConfig;
    } else if (this.destinationId === DataOnDemandDestinationType.AWS) {
      this.result.dodLayout.awsConfig = this.awsConfig;
    }

    this.Result.ResultType = DialogResultType.Ok;
    this.Result.ResultData = this.result;
    this.dialogRef.close(this.Result);
  }
}

export class AdditionalData
{
  public dodEndPointSubDataId: number;
  public key: string;
  public title: string;
  public selected: boolean;
}

export interface ColumnSelection extends DodEndPointColumn
{
  selected: boolean;
}

export interface DimensionSelection extends DodEndPointDimension
{
  selected: boolean;
}

export interface MeasureSelection extends DodEndPointMeasureEx
{
  selected: boolean;
  selectedAggregate: DodEndPointAggregateType;
}
